/**
 * Resources/view Controller
 *
 * Displays details on a specific resource
 */

// the constructor for this object
function ResourcesViewController() { }

// the object
ResourcesViewController.prototype = {
    constructor: ResourcesViewController,

    // the category id to search for resources
    resourceId: false,

    // initialize the controller
    init: function()
    {
        // redirect the user if they're not logged in
        PortalMain.authRedirect();

        // register the route variables used by this controller
        this._registerRouteVariables();

        PortalHelper.debugMessage('Resources View Initialized');
    },

    // run the controller
    run: function()
    {
        // get and populate the orders
        this._getResource();

        // register the events used by this controller
        this._registerEvents();

        PortalHelper.debugMessage('Resources View Controller Ran');
    },

    // get the route variables and include them in the controller
    _registerRouteVariables: function()
    {
        var segments = PortalMain.getRouteSegments();

        // set the category id
        if (segments.length == 1) {
            this.resourceId = segments[0];
        } else {
            PortalHelper.sendToDashboard();
        }
    },

    // register the javascript events
    _registerEvents:  function()
    {

    },

    // get the resources from the website api
    _getResource: function()
    {
        // build the url
        var resourceUrl = PortalConfig.resourcesUrl;
        resourceUrl += this.resourceId + '/';

        // make the request
        $.ajax({
            url: resourceUrl,
            method: 'GET',
            success: function(data){
                // Populate the details of the resource
                PortalMain.ResourcesViewController._populateResource(data);

                // turn off the loading, and the start-hidden
                PortalHelper.loadingOverlay('#resource-details', false);
            }
        });
    },

    // populate the resources list
    _populateResource: function(resourceData)
    {
        var resource = resourceData.data[0];

        // set the title
        $('#resource-title').html(resource.title);

        // set the content
        $('.resources__content').html(resource.body);

        // set the date
        var dateArr = resource.postDate.date.split(/[^0-9]/);
        var date = new Date (dateArr[0], dateArr[1]-1, dateArr[2], dateArr[3], dateArr[4], dateArr[5]);

        $('.resources__meta .date').text(
            PortalMain.ResourcesViewController._formatPostDate(date)
        )

    },

    _formatPostDate: function(date)
    {
        var monthNames = [
            "January", "February", "March",
            "April", "May", "June", "July",
            "August", "September", "October",
            "November", "December"
        ];

        var month = date.getMonth();
        var day = date.getDate();
        var year = date.getFullYear();

        return monthNames[month] + ' ' + day + ', ' + year;

    },

}